import React from 'react'
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaLinkedinIn, FaFax, FaWhatsapp } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

function Footer() {
    const { t } = useTranslation();
    return (
        <>

            <footer className="footer-section text-white" style={{ backgroundColor: "rgba(9, 26, 58, 1)" }}>
                <div className="container py-5">
                    <div className="row text-start">

                        {/* Company Info */}
                        <div className="col-md-4 mb-4">
                            <h5 className="fw-bold mb-3 text-white"
                                style={{
                                    textDecoration: "underline",
                                    textDecorationThickness: "1px",
                                    textUnderlineOffset: "5px",
                                }}
                            >
                                TNWC
                            </h5>
                            <p className="small">
                                {t("footerCompanyDesc")}
                            </p>
                        </div>

                        {/* Quick Links */}
                        <div className="col-md-2 mb-4">
                            <h6 className="fw-bold mb-3 text-white"
                                style={{
                                    textDecoration: "underline",
                                    textDecorationThickness: "1px",
                                    textUnderlineOffset: "5px",
                                }}
                            >
                                {t("footerQuickLinks")}
                            </h6>
                            <ul className="footer-links" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                                <li className='my-2'><a href="/contact-us" className='text-white text-decoration-none'>{t("footerContactUs")}</a></li>
                                <li className='my-2'><a href="/rti" className='text-white text-decoration-none'>{t("footerRTILogin")}</a></li>
                                <li className='my-2'><a href="/gallery" className='text-white text-decoration-none'>{t("footerPhotoGallery")}</a></li>
                            </ul>
                        </div>

                        {/* Services */}
                        <div className="col-md-3 mb-4">
                            <h6 className="fw-bold mb-3 text-white"
                                style={{
                                    textDecoration: "underline",
                                    textDecorationThickness: "1px",
                                    textUnderlineOffset: "5px",
                                }}
                            >
                                {t("footerHelpAndSupport")}
                            </h6>
                            <ul className="footer-links" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                                <li className="my-2">
                                    <a href="/disclaimer" className="text-white text-decoration-none">
                                        {t("footerDisclaimer")}
                                    </a>
                                </li>
                                <li className="my-2">
                                    <a href="/Copyrights" className="text-white text-decoration-none">
                                        {t("footerCopyrightPolicy")}
                                    </a>
                                </li>
                                <li className="my-2">
                                    <a href="/privacy" className="text-white text-decoration-none">
                                        {t("footerPrivacyPolicy")}
                                    </a>
                                </li>
                                <li className="my-2">
                                    <a href="/hyperlink" className="text-white text-decoration-none">
                                        {t("footerHyperlinkingPolicy")}
                                    </a>
                                </li>
                                <li className="my-2">
                                    <a href="/accessibility" className="text-white text-decoration-none">
                                        {t("footerAccessibility")}
                                    </a>
                                </li>
                                <li className="my-2">
                                    <a href="/termsandconditions" className="text-white text-decoration-none">
                                        {t("footerTermsandConditions")}
                                    </a>
                                </li>
                            </ul>


                        </div>

                        {/* Contact Info */}
                        <div className="col-md-3 mb-4">
                            <h6 className="fw-bold mb-3 text-white"
                                style={{
                                    textDecoration: "underline",
                                    textDecorationThickness: "1px",
                                    textUnderlineOffset: "5px",
                                }}
                            >
                                {t("footerAddress")}
                            </h6>
                            <p className="small mb-1">
                                <FaMapMarkerAlt /> {t("contactAddress")}
                            </p>

                            <h6 className="fw-bold my-3 text-white"
                                style={{
                                    textDecoration: "underline",
                                    textDecorationThickness: "1px",
                                    textUnderlineOffset: "5px",
                                }}
                            >
                                {t("footerContact")}
                            </h6>
                            <div className="d-flex gap-2 mb-2">
                                <a href={`tel:${t('contactPhoneog1')}`} className="d-flex gap-2 text-decoration-none text-white small">
                                    <FaPhoneAlt />
                                    <p className='m-0'>{t('contactPhone1')}</p>
                                </a>
                                <span>,</span>
                                <a href={`tel:${t('contactPhoneog2')}`} className="d-flex gap-2 text-decoration-none text-white small">
                                    <p className='m-0'>{t('contactPhone2')}</p>
                                </a>
                            </div>

                            <a href={`tel:${t('faxog')}`} className="d-flex gap-2 text-decoration-none text-white small">
                                <FaFax />
                                <p className='m-0'>{t('fax')}</p>
                            </a>

                            <a href={`mailto:${t('contactEmailog')}`} className="d-flex gap-2 text-decoration-none text-white small">
                                <FaEnvelope />
                                <p className='m-0'>{t('contactEmail')}</p>
                            </a>

                            <a
                                href={`https://wa.me/${t('whatsappog').replace(/\D/g, '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex gap-2 text-decoration-none text-white small"
                            >
                                <FaWhatsapp />
                                <p className='m-0'>{t('whatsapp')}</p>
                            </a>

                            {/* Social Icons */}
                            <h6 className="fw-bold my-3 text-white"
                                style={{
                                    textDecoration: "underline",
                                    textDecorationThickness: "1px",
                                    textUnderlineOffset: "5px",
                                }}
                            >
                                {t("footerFollowUs")}
                            </h6>
                            <div className="footer-social d-flex justify-content-start gap-3 mt-3">
                                <a href="/"><FaFacebookF /></a>
                                <a href="/"><FaInstagram /></a>
                                <a href="/"><FaLinkedinIn /></a>
                            </div>

                        </div>

                    </div>
                </div>

                <div className=" text-danger ">
                    <hr className="w-75 opacity-90 mx-auto" style={{ color: "white" }} />
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom text-center py-3">
                    {t("footerCopyright")}
                </div>
            </footer>
        </>

    );
}

export default Footer